module.exports = __webpack_public_path__ + "img/heketaikeji-logo2.b21185c1.png";